import React from 'react';
import { Routes, Route } from 'react-router-dom';

import { NoDogfoodingWarning } from '../../components/NoDogfoodingWarning';

import { OrderList } from './components';

export const OrdersPage: React.FC = () => {
  return (
    <>
      <NoDogfoodingWarning subject="orders" />
      <Routes>
        <Route index element={<OrderList />} />
      </Routes>
    </>
  );
};
